
import { Link } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";
import { scrollToTop } from "@/utils/navigation";

export const NavbarLogo = () => {
  const isMobile = useIsMobile();
  
  return (
    <Link to="/" className="flex items-center gap-2" onClick={scrollToTop}>
      <div className="flex items-center">
        <img
          src="/lovable-uploads/f9834a35-b485-4f1a-b892-78205d1aa8b4.png"
          alt="Service Icon"
          className={`w-auto transition-all duration-300 ${
            isMobile ? 'h-[16px]' : 'h-[22px]'
          }`}
        />
        <img
          src="/lovable-uploads/36343729-3ba6-41b0-ba68-16a8900a03bb.png"
          alt="647.Repair Logo - Professional Appliance Repair in Toronto"
          className={`w-auto ml-2 transition-all duration-300 ${
            isMobile ? 'h-3' : 'h-[16px]'
          }`}
        />
      </div>
    </Link>
  );
};
